import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import { AnimatePresence, motion } from "framer-motion";

import FnrCheckbox from "UI/FnrEnrichedCheckbox/FnrCheckbox";

CheckboxSection.propTypes = {
  enabled: PropTypes.bool,
  onToggle: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  errorMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default function CheckboxSection({
  enabled,
  onToggle,
  label,
  loading,
  errorMessage,
  disabled,
  children,
}) {
  // id used for aria-labelledby
  let id = label.split(" ").join("_").toLowerCase();

  // TODO: This should get the value of whatever disabled flag we are using
  let disabledFlag = false;

  let isDisabled =
    disabled === undefined || disabled === null ? disabledFlag : disabled;

  return (
    <Section disabled={isDisabled}>
      <FnrCheckbox
        on={enabled}
        toggleOn={onToggle}
        id={id}
        color="#016099"
        disabled={disabled}
        loading={loading}
        data-cy="fnrCheckbox"
      />

      <ContentWrapper>
        <label id={id} onClick={onToggle} data-cy="famRegCheckboxLabel">
          {label}
        </label>
        <AnimatePresence initial={false}>
          {errorMessage ? (
            <Error
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
            >
              {errorMessage}
            </Error>
          ) : null}
        </AnimatePresence>

        {children && (
          <Content
            initial={false}
            animate={
              enabled
                ? {
                    height: "auto",
                    opacity: 1,
                    y: 0,
                  }
                : { height: 0, opacity: 0, y: -8 }
            }
          >
            <ContentInside>{children}</ContentInside>
          </Content>
        )}
      </ContentWrapper>
    </Section>
  );
}

const Section = styled.section`
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
  opacity: ${(props) => (props.disabled ? 0.65 : 1)};
`;
const ContentWrapper = styled.div`
  flex: 1 0 275px;
`;
const Content = styled(motion.div)`
  overflow: hidden;
  padding-left: 4px;
  margin-left: -4px;
`;

const Error = styled(motion.div)`
  /* TODO: Restyle this to match other error messages colors and padding */
  background: #f8f1d7;
  color: #8c6d00;
  padding: 4px 6px;
  border-radius: 4px;
`;

const ContentInside = styled.div`
  padding: 9px 0;
`;
